import { Form, Switch, Typography } from "antd";
import { useLoader } from "../../../Context/LoaderContext";
import { FormProps } from "../FormProps";

const ConductInterviewToggle: React.FC<FormProps> = ({
  settings,
  updateSettings,
}) => {
  const { isLoading } = useLoader();

  const changeAvailability = async () => {
    if (settings) {
      settings.availableForInterviews = !settings.availableForInterviews;
      await updateSettings(settings, false, false);
    }
  };

  return (
    <div id="conduct-interview-toggle">
      <Form.Item
        style={{ margin: 0 }}
        name="availableForInterviews"
        rules={[
          {
            required: true,
            message: "Please confirm if you conduct interviews!",
          },
        ]}
        label={
          <Typography.Title
            level={5}
            type="secondary"
            style={{ margin: 0, fontWeight: "normal" }}
          >
            Do you conduct interviews ?
          </Typography.Title>
        }
      >
        <Switch
          loading={isLoading}
          checked={settings?.availableForInterviews}
          onChange={() => changeAvailability()}
        />
      </Form.Item>
    </div>
  );
};

export default ConductInterviewToggle;